import { grey, lightBlue } from '@mui/material/colors';
import { createTheme, styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';
import React__default, { useMemo, useState, useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { AsyncState, LoadFight, RecordingState, FightModerationMode, CreateFightCommand, ChessFightRules, FreeFightRules, Vote, LoadVoting, SendChatMessage } from '@tatami/domain';
import { createSlice, createAsyncThunk, configureStore } from '@reduxjs/toolkit';
import useSWR from 'swr';
import axios from 'axios';
import ColorHash from 'color-hash';
import { jsx, jsxs } from 'react/jsx-runtime';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Container, Alert, Skeleton, Avatar as Avatar$1, IconButton, styled as styled$1, Typography as Typography$1, Fab, useTheme, Box, LinearProgress, Toolbar, Slide, Slider, Stack, SvgIcon, Grow, FormControl, InputLabel, FilledInput, Paper, Zoom, ListItem, ListItemText, List, Grid, Chip, alpha, css as css$1, Link } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { getAuth, onAuthStateChanged, GoogleAuthProvider, EmailAuthProvider } from 'firebase/auth';
import { useFirebaseApp, useSigninCheck } from 'reactfire';
import { jsx as jsx$1, jsxs as jsxs$1, Fragment } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';
import Hls from 'hls.js';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SendIcon from '@mui/icons-material/Send';
import { useFormik } from 'formik';
import * as yup from 'yup';

// A custom theme for this app
// src/ui/theme/index.js
var refTheme = createTheme();
var palette = {
    background: {
    //default: "#f59e42",
    },
    primary: { main: "#6bc9df" },
    secondary: { main: "#de9554" },
    third: refTheme.palette.augmentColor({ color: { main: "#ca81de" } }),
};
var components = {
    MuiAppBar: {
        styleOverrides: {
            root: {
                backgroundColor: grey[200],
            },
        },
    },
};
var tatamiTheme = createTheme({
    components: components,
    palette: palette,
});

// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = useDispatch;
var useAppSelector = useSelector;

function useQuery() {
    var search = useLocation().search;
    return useMemo(function () { return new URLSearchParams(search); }, [search]);
}

var _a$4;
var FightPhaseName;
(function (FightPhaseName) {
    FightPhaseName["Lobby"] = "Lobby";
    FightPhaseName["Introduction"] = "Introduction";
    FightPhaseName["Fight"] = "Fight";
    FightPhaseName["Closing"] = "Closing";
    FightPhaseName["End"] = "End";
})(FightPhaseName || (FightPhaseName = {}));
var FightStatus;
(function (FightStatus) {
    FightStatus["CREATED"] = "CREATED";
    FightStatus["JOINING"] = "JOINING";
    FightStatus["EMITTING"] = "EMITTING";
    FightStatus["PAUSED"] = "PAUSED";
    FightStatus["FINISHED"] = "FINISHED";
})(FightStatus || (FightStatus = {}));
var StreamEventState;
(function (StreamEventState) {
    StreamEventState["Starting"] = "Starting";
    StreamEventState["Started"] = "Started";
})(StreamEventState || (StreamEventState = {}));
var initialState$8 = {
    fight: undefined,
    error: undefined,
    streamState: undefined,
};
var fightSlice = createSlice({
    name: "fight",
    initialState: initialState$8,
    reducers: {
        fightLoaded: function (state, _a) {
            var payload = _a.payload;
            state.fight = payload.fight;
        },
        streamStateUpdated: function (state, _a) {
            var payload = _a.payload;
            state.streamState = payload.state;
        },
        fightStatusChanged: function (state, _a) {
            var payload = _a.payload;
            if (state.fight)
                state.fight.status = payload.fightStatus;
        },
        fightError: function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
        },
        resetFight: function (state) { return initialState$8; },
    },
});
var fightLoaded = (_a$4 = fightSlice.actions, _a$4.fightLoaded), streamStateUpdated = _a$4.streamStateUpdated, fightError = _a$4.fightError, resetFight = _a$4.resetFight, fightStatusChanged = _a$4.fightStatusChanged;
var selectFight = function (state) { return state.fight.fight; };
var selectError = function (state) { return state.fight.error; };
var fightReducer = fightSlice.reducer;

var _a$3;
var FightMediaMode;
(function (FightMediaMode) {
    FightMediaMode["Live"] = "LIVE";
    FightMediaMode["VOD"] = "VOD";
})(FightMediaMode || (FightMediaMode = {}));
var initialState$7 = {
    ownVote: {
        state: AsyncState.Unitialized,
    },
};
var bleacherSlice = createSlice({
    name: "bleacher",
    initialState: initialState$7,
    reducers: {
        fightMediaLoaded: function (state, _a) {
            var payload = _a.payload;
            state.media = payload.media;
        },
        votingResultsUpdated: function (state, _a) {
            var _b;
            var payload = _a.payload;
            state.voting = (_b = payload.voting) === null || _b === void 0 ? void 0 : _b.results;
        },
        loadingOwnVote: function (state) {
            state.ownVote.state = AsyncState.Fetching;
        },
        voteLoaded: function (state, _a) {
            var _b;
            var payload = _a.payload;
            state.ownVote.state = AsyncState.Completed;
            state.ownVote.fighterUid = (_b = payload.vote) === null || _b === void 0 ? void 0 : _b.fighterUid;
        },
        voteStarted: function (state) {
            state.ownVote.state = AsyncState.Fetching;
        },
        voted: function (state, _a) {
            var payload = _a.payload;
            state.ownVote.fighterUid = payload.fighterUid;
            state.ownVote.state = AsyncState.Completed;
        },
        fightMediaChanged: function (state, _a) {
            var payload = _a.payload;
            state.media = payload.media;
        },
        resetBleacher: function (state) { return initialState$7; },
    },
});
var votingResultsUpdated = (_a$3 = bleacherSlice.actions, _a$3.votingResultsUpdated), resetBleacher = _a$3.resetBleacher, voted = _a$3.voted, loadingOwnVote = _a$3.loadingOwnVote, voteLoaded = _a$3.voteLoaded, voteStarted = _a$3.voteStarted, fightMediaLoaded = _a$3.fightMediaLoaded, fightMediaChanged = _a$3.fightMediaChanged;
var bleacherReducer = bleacherSlice.reducer;
var selectOwnVote = function (state) { return state.bleacher.ownVote; };
var selectVoteResults = function (state) { return state.bleacher.voting; };
var selectBleacher = function (state) { return state.bleacher; };
var bleacherReducer$1 = bleacherSlice.reducer;

var RouterContext = React__default.createContext(undefined);
var RouterContextProvider = RouterContext.Provider;
var useRouterContext = function () {
    var context = React__default.useContext(RouterContext);
    if (context === undefined) {
        throw new Error("useRouterContext must be used within a RouterContextProvider");
    }
    return context;
};

var WSState;
(function (WSState) {
    WSState["Unitialized"] = "Unitialized";
    WSState["Connecting"] = "Connecting";
    WSState["Connected"] = "Connected";
    WSState["Closed"] = "Closed";
    WSState["Failed"] = "Failed";
    WSState["Backoff"] = "Backoff";
})(WSState || (WSState = {}));
function useBleacher(wsSession, fightUid) {
    var dispatch = useDispatch();
    var router = useRouterContext();
    var connectionTries = 0;
    var _a = useState(WSState.Unitialized), wsState = _a[0], setWsState = _a[1];
    var onWSOpenHandler = useCallback(function () {
        setWsState(WSState.Connected);
        connectionTries = 0;
        if (!fightUid)
            return;
        // dispatch(fightRoomWSConnected());
        this.send(JSON.stringify(new LoadFight(fightUid)));
    }, [fightUid]);
    var onWSErrorHandler = useCallback(function () {
        setWsState(WSState.Failed);
        if (connectionTries > 2)
            router.navigate("/error/ConnectionError");
    }, [router]);
    var onWSCloseHandler = useCallback(function (ev) {
        if (ev.code !== 1000) {
            console.warn("The Websocket connection was closed unexpectedly", ev.reason);
            setWsState(WSState.Failed);
            connectionTries = connectionTries + 1;
            if (connectionTries > 2)
                router.navigate("/error/ConnectionError");
        }
        else {
            setWsState(WSState.Closed);
        }
    }, [router]);
    var onWSMessageHandler = useCallback(function (event) {
        var message = JSON.parse(event.data);
        switch (message["_type"]) {
            case "FightFoundResult":
                dispatch(fightLoaded(message));
                dispatch(fightMediaLoaded(message));
                break;
            case "FightStatusChanged":
                dispatch(fightStatusChanged(message));
                break;
            case "MediaUpdated":
                dispatch(fightMediaChanged(message));
                break;
            case "FightNotFoundResult":
                router.navigate("/error/404");
                break;
        }
    }, [dispatch, router]);
    useEffect(function () {
        if (!fightUid || wsState !== WSState.Unitialized)
            return;
        wsSession.current = new WebSocket("".concat(process.env.NEXT_PUBLIC_WEBSOCKET_BASE_URL ||
            process.env.REACT_APP_WEBSOCKET_BASE_URL, "/view"));
        setWsState(WSState.Connecting);
        wsSession.current.addEventListener("message", onWSMessageHandler);
        wsSession.current.addEventListener("open", onWSOpenHandler);
        wsSession.current.addEventListener("error", onWSErrorHandler);
        // First, an unexpected close of the connection is considered an error, in the cleaning, we remove the listener as the close is expected then
        wsSession.current.addEventListener("close", onWSCloseHandler);
        return function () { };
    }, [
        fightUid,
        onWSMessageHandler,
        onWSOpenHandler,
        onWSErrorHandler,
        onWSCloseHandler,
        dispatch,
        wsState,
    ]);
    useEffect(function () {
        if (wsState === WSState.Failed)
            window.setTimeout(function () {
                connectionTries = connectionTries + 1;
                setWsState(WSState.Unitialized);
            }, 2000);
        return function () { };
    }, [wsState]);
    useEffect(function () {
        return function () {
            if (fightUid &&
                wsSession.current &&
                wsSession.current.readyState !== WebSocket.CLOSING &&
                wsSession.current.readyState !== WebSocket.CLOSED) {
                wsSession.current.removeEventListener("message", onWSMessageHandler);
                wsSession.current.removeEventListener("open", onWSOpenHandler);
                wsSession.current.removeEventListener("error", onWSErrorHandler);
                if (wsSession.current.readyState === WebSocket.CONNECTING) {
                    wsSession.current.addEventListener("open", function () {
                        this.close(1000, "Cleaning up effect");
                    });
                }
                else {
                    wsSession.current.close(1000, "Cleaning up effect");
                }
            }
            wsSession.current = undefined;
            dispatch(resetBleacher());
        };
    }, [fightUid]);
    return wsState;
}

var API = axios.create({
    baseURL: process.env.NEXT_PUBLIC_REST_BASE_URL ||
        process.env.REACT_APP_REST_BASE_URL,
    withCredentials: true,
});

var colorGenerator$1 = new ColorHash({ saturation: 0.6, lightness: 0.5 });
var profileFetcher = function (url) {
    return API.get(url).then(function (res) {
        var profile = res.data;
        if (profile.displayName) {
            var color = colorGenerator$1.rgb(profile.displayName);
            profile = Object.assign(profile, {
                color: { r: color[0], g: color[1], b: color[2] },
            });
        }
        return profile;
    });
};
function useProfile(uid) {
    var _a = useSWR(uid ? "/profiles/profile/".concat(uid) : null, profileFetcher, { revalidateIfStale: false }), data = _a.data, error = _a.error, isLoading = _a.isLoading, mutate = _a.mutate;
    return {
        profile: data,
        isLoading: isLoading,
        error: error,
        mutate: mutate,
    };
}

var statsFetcher = function (url) {
    return API.get(url, {}).then(function (res) {
        return res.data;
    });
};
function useProfileStats(uid) {
    var _a = useSWR(uid ? "/profiles/profile/".concat(uid, "/stats") : null, statsFetcher), data = _a.data, error = _a.error, isLoading = _a.isLoading, mutate = _a.mutate;
    return {
        stats: data,
        isLoading: isLoading,
        error: error,
        mutate: mutate,
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var USER_FIGHTS_PAGE_SIZE = 6;
var userFightsFetcher = function (_a) {
    var url = _a.url, paging = _a.paging;
    return API.get(url, {
        params: __assign({}, paging),
    }).then(function (res) {
        return res.data;
    });
};
function useUserFights(page, url) {
    var _a = useSWR(url
        ? {
            url: url,
            paging: {
                limit: USER_FIGHTS_PAGE_SIZE,
                offset: (page - 1) * USER_FIGHTS_PAGE_SIZE,
            },
        }
        : null, userFightsFetcher), data = _a.data, error = _a.error, isLoading = _a.isLoading, mutate = _a.mutate;
    return {
        fights: data,
        isLoading: isLoading,
        error: error,
        mutate: mutate,
    };
}

var useScript = function (url) {
    var _a = useState(false), loaded = _a[0], setLoaded = _a[1];
    useEffect(function () {
        var script = document.createElement("script");
        script.addEventListener("load", function () {
            setLoaded(true);
        });
        script.type = "text/javascript";
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
        return function () {
            document.body.removeChild(script);
        };
    }, [url]);
    return loaded;
};

function formatMinutes(value) {
    return "".concat(value / 60, "m");
}
function toHHMMSS(sec_num) {
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = Math.floor(sec_num - hours * 3600 - minutes * 60);
    var hoursStr;
    var minutesStr;
    var secondsStr;
    if (hours === 0)
        hoursStr = "";
    else if (hours < 10)
        hoursStr = "0" + hours + ":";
    else
        hoursStr = hours.toString() + ":";
    if (minutes < 10)
        minutesStr = "0" + minutes;
    else
        minutesStr = minutes.toString();
    if (seconds < 10)
        secondsStr = "0" + seconds;
    else
        secondsStr = seconds.toString();
    return hoursStr + minutesStr + ":" + secondsStr;
}

var enumFromValue = function (val, _enum) {
    var enumName = Object.keys(_enum).find(function (k) { return _enum[k] === val; });
    if (!enumName) {
        console.warn("Value not found in the given enum", val, _enum); // here fail fast as an example
        return undefined;
    }
    return _enum[enumName];
};

var _a$2;
var ClientPreparationStep;
(function (ClientPreparationStep) {
    ClientPreparationStep["Connect"] = "Connect";
})(ClientPreparationStep || (ClientPreparationStep = {}));
var PreparationStepState;
(function (PreparationStepState) {
    PreparationStepState["Inactive"] = "Inactive";
    PreparationStepState["Processing"] = "Processing";
    PreparationStepState["Ready"] = "Ready";
    PreparationStepState["Failed"] = "Failed";
})(PreparationStepState || (PreparationStepState = {}));
var initialState$6 = {
    room: undefined,
    connected: false,
    joined: false,
    live: false,
    availableActions: {
        fight: {},
        fighter: {},
    },
    preparation: { steps: {} },
};
var fightRoomSlice = createSlice({
    name: "fightRoom",
    initialState: initialState$6,
    reducers: {
        fightRoomJoined: function (state) {
            state.joined = true;
        },
        fightRoomLeft: function (state, _a) {
            var payload = _a.payload;
            state.room = payload;
        },
        fightParticipantsChanged: function (state, _a) {
            var payload = _a.payload;
            state.room = payload;
        },
        fightRoomWSConnected: function (state) {
            state.connected = true;
        },
        availableActionsChanged: function (state, _a) {
            var payload = _a.payload;
            state.availableActions = payload;
        },
        recordingStateChanged: function (state, _a) {
            var payload = _a.payload;
            state.live = payload === RecordingState.Recording;
        },
        preparationStepUpdate: function (state, _a) {
            var payload = _a.payload;
            state.preparation.steps[payload.step] = payload.status;
        },
        resetFightRoom: function (state) { return initialState$6; },
    },
});
var fightRoomJoined = (_a$2 = fightRoomSlice.actions, _a$2.fightRoomJoined), fightRoomLeft = _a$2.fightRoomLeft, fightParticipantsChanged = _a$2.fightParticipantsChanged, fightRoomWSConnected = _a$2.fightRoomWSConnected, availableActionsChanged = _a$2.availableActionsChanged, resetFightRoom = _a$2.resetFightRoom, recordingStateChanged = _a$2.recordingStateChanged, preparationStepUpdate = _a$2.preparationStepUpdate;
var selectFightRoom = function (state) { return state.fightRoom; };
var selectAvailableActions = function (state) {
    return state.fightRoom.availableActions;
};
var fightRoomReducer = fightRoomSlice.reducer;

var initialState$5 = {
    title: "",
    description: "",
    lang: "",
    uid: "",
};
var createFightSlice = createSlice({
    name: "fight",
    initialState: initialState$5,
    reducers: {
        setCurrentFight: function (state, action) {
            action.payload;
        },
    },
});
var setCurrentFight = createFightSlice.actions.setCurrentFight;
var formValuesToCommand = function (values) {
    switch (values.mode) {
        case FightModerationMode.Free:
            if (!values.freeFightRules) {
                throw new Error("Rules were not present in the form values.");
            }
            return new CreateFightCommand(values.title, values.description, values.lang, values.mode, new FreeFightRules(values.freeFightRules.maxDuration, values.fightRules.introductionDuration, values.fightRules.closeDuration));
        case FightModerationMode.Chess:
            if (!values.chessFightRules) {
                throw new Error("Simple time fight rules were not present in the form values.");
            }
            return new CreateFightCommand(values.title, values.description, values.lang, values.mode, new ChessFightRules(values.chessFightRules.maxSpeechDuration, values.fightRules.introductionDuration, values.fightRules.closeDuration));
        default:
            throw new Error("No valid fight mode.");
    }
};
var createFight = function (payload) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.post("/fight/create", formValuesToCommand(payload))];
                case 1:
                    response = _a.sent();
                    dispatch(setCurrentFight(response.data));
                    return [2 /*return*/, response.data];
            }
        });
    }); };
};
var createFightReducer = createFightSlice.reducer;

var _a$1;
var MediaDevicesKeys = {
    selectedMic: "selectedMic",
    selectedCam: "selectedCam",
    selectedSpeaker: "selectedSpeaker",
};
var initialState$4 = {
    selectedMic: (typeof window !== "undefined" &&
        window.sessionStorage.getItem(MediaDevicesKeys.selectedMic)) ||
        undefined,
    selectedCam: (typeof window !== "undefined" &&
        window.sessionStorage.getItem(MediaDevicesKeys.selectedCam)) ||
        undefined,
    selectedSpeaker: (typeof window !== "undefined" &&
        (window === null || window === void 0 ? void 0 : window.sessionStorage.getItem(MediaDevicesKeys.selectedSpeaker))) ||
        undefined,
};
var mediaDevicesSlice = createSlice({
    name: "mediaDevices",
    initialState: initialState$4,
    reducers: {
        setDeviceSelection: function (state, action) {
            sessionStorage.setItem(MediaDevicesKeys.selectedMic, action.payload.selectedMic);
            sessionStorage.setItem(MediaDevicesKeys.selectedCam, action.payload.selectedCam);
            sessionStorage.setItem(MediaDevicesKeys.selectedSpeaker, action.payload.selectedSpeaker);
            state = action.payload;
            return state;
        },
        cleanDeviceSelection: function (state) {
            sessionStorage.removeItem(MediaDevicesKeys.selectedSpeaker);
            sessionStorage.removeItem(MediaDevicesKeys.selectedCam);
            sessionStorage.removeItem(MediaDevicesKeys.selectedMic);
            return {};
        },
    },
});
var setDeviceSelection = (_a$1 = mediaDevicesSlice.actions, _a$1.setDeviceSelection), cleanDeviceSelection = _a$1.cleanDeviceSelection;
var selectDeviceSelection = function (state) { return state.mediaDevices; };
var mediaDevicesReducer = mediaDevicesSlice.reducer;

var initialState$3 = {};
var webrtcSlice = createSlice({
    name: "webrtc",
    initialState: initialState$3,
    reducers: {
        iceServersUnused: function (state, _a) {
            var payload = _a.payload;
            delete state[payload];
        },
    },
    extraReducers: function (builder) {
        builder.addCase(fetchIceServers.fulfilled, function (state, _a) {
            var payload = _a.payload;
            payload.urls = payload.urls.slice(0, 2);
            state[payload.id] = {
                iceServers: payload,
            };
        });
        //TODO builder.addCase(fetchIceServers.pending, (state, action) => {});
    },
});
var iceServersUnused = webrtcSlice.actions.iceServersUnused;
var fetchIceServers = createAsyncThunk("webrtc/iceServers", function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, API.get("/webrtc/turn")];
            case 1:
                response = _a.sent();
                return [2 /*return*/, __assign(__assign({}, response.data.iceServers), { id: id })];
        }
    });
}); });
var selectIceServers = function (id) { return function (state) { var _a; return (_a = state.webrtc[id]) === null || _a === void 0 ? void 0 : _a.iceServers; }; };
var webrtcReducer = webrtcSlice.reducer;

var initialState$2 = {
    fetchedOnce: false,
    fetching: false,
};
var colorGenerator = new ColorHash({ lightness: 0.5 });
var sessionSlice = createSlice({
    name: "session",
    initialState: initialState$2,
    reducers: {
        clearLoginState: function (state) {
            delete state.user;
        },
    },
    extraReducers: function (builder) {
        builder.addCase(fetchSessionState.pending, function (state, action) {
            state.fetching = true;
            state.fetchedOnce = true;
        });
        builder.addCase(fetchSessionState.fulfilled, function (state, action) {
            state.fetching = false;
            state.sid = action.payload.sid;
            if (typeof action.payload.user !== "undefined") {
                var color = colorGenerator.rgb(action.payload.user.displayName);
                state.user = Object.assign(action.payload.user, {
                    color: { r: color[0], g: color[1], b: color[2] },
                });
            }
        });
        builder.addCase(fetchSessionState.rejected, function (state, action) {
            state.fetching = false;
        });
    },
});
var clearLoginState = sessionSlice.actions.clearLoginState;
var fetchSessionState = createAsyncThunk("session/fetch", function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, API.get("/session")];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
var selectSessionState = function (state) { return state.session; };
var selectCurrentUser = function (state) { return state.session.user; };
var sessionReducer = sessionSlice.reducer;

var _a;
var initialState$1 = {
    messages: [],
};
var chatSlice = createSlice({
    name: "fightRoom",
    initialState: initialState$1,
    reducers: {
        chatMessageReceived: function (state, _a) {
            var payload = _a.payload;
            if (!state.messages.find(function (m) { return m.id === payload.id; }))
                state.messages.push(payload);
        },
        resetChat: function (state) { return initialState$1; },
    },
});
var resetChat = (_a = chatSlice.actions, _a.resetChat), chatMessageReceived = _a.chatMessageReceived;
var selectChat = function (state) { return state.chat; };
var chatReducer = chatSlice.reducer;

var initialState = {
    fetching: false,
    fights: [],
};
var homeSlice = createSlice({
    name: "home",
    initialState: initialState,
    reducers: {
        resetHome: function (state) { return initialState; },
    },
    extraReducers: function (builder) {
        builder.addCase(fetchFights.fulfilled, function (state, action) {
            state.fetching = false;
            state.fights = state.fights.concat(action.payload);
        });
        builder.addCase(fetchFights.pending, function (state, action) {
            state.fetching = true;
        });
    },
});
var fetchFights = createAsyncThunk("home/fetch", function (feedReq) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, API.get("/fight/fights", {
                    params: {
                        before: feedReq.before,
                        limit: feedReq.limit,
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); }, {
    condition: function (feedReq, _a) {
        var getState = _a.getState; _a.extra;
        var home = getState().home;
        if (home.fetching) {
            // Already fetched or in progress, don't need to re-fetch
            return false;
        }
    },
});
var resetHome = homeSlice.actions.resetHome;
var selectHomeState = function (state) { return state.home; };
var homeReducer = homeSlice.reducer;

var store = configureStore({
    reducer: {
        createFight: createFightReducer,
        fight: fightReducer,
        fightRoom: fightRoomReducer,
        mediaDevices: mediaDevicesReducer,
        bleacher: bleacherReducer$1,
        session: sessionReducer,
        webrtc: webrtcReducer,
        chat: chatReducer,
        home: homeReducer,
    },
});

var BleacherContext = React__default.createContext(undefined);
var BleacherContextProvider = BleacherContext.Provider;
var useBleacherContext = function () {
    var context = React__default.useContext(BleacherContext);
    if (context === undefined) {
        throw new Error("useBleacherContext must be used within a BleacherContextProvider");
    }
    return context;
};

var ChatContext = React__default.createContext(undefined);
var ChatContextProvider = ChatContext.Provider;
var useChatContext = function () {
    var context = React__default.useContext(ChatContext);
    if (context === undefined) {
        throw new Error("useChatContext must be used within a ChatContextProvider");
    }
    return context;
};

var TranslationContext = React__default.createContext(undefined);
var TranslationContextProvider = TranslationContext.Provider;
var useTranslationContext = function () {
    var context = React__default.useContext(TranslationContext);
    if (context === undefined) {
        throw new Error("useTranslationContext must be used within a TranslationContextProvider");
    }
    return context;
};

var StyledFirebaseAuth = function (_a) {
    var className = _a.className, uiConfig = _a.uiConfig;
    var elementRef = useRef(null);
    var app = useFirebaseApp(); // a parent component contains a `FirebaseAppProvider`
    var auth = getAuth(app);
    var _b = useSigninCheck(); _b.status; var data = _b.data;
    var loadFirebaseui = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var firebaseui, firebaseUiWidget, unregisterAuthObserver;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import('firebaseui')];
                case 1:
                    firebaseui = _a.sent();
                    firebaseUiWidget = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
                    if (uiConfig.signInFlow === "popup")
                        firebaseUiWidget.reset();
                    unregisterAuthObserver = onAuthStateChanged(auth, function (user) {
                        if (!user && (data === null || data === void 0 ? void 0 : data.signedIn))
                            firebaseUiWidget.reset();
                    });
                    // Trigger the callback if any was set.
                    // if (uiCallback) uiCallback(firebaseUiWidget);
                    // Render the firebaseUi Widget.
                    // @ts-ignore
                    firebaseUiWidget.start(elementRef.current, uiConfig);
                    return [2 /*return*/, function () {
                            unregisterAuthObserver();
                            firebaseUiWidget.reset();
                        }];
            }
        });
    }); }, [uiConfig, data === null || data === void 0 ? void 0 : data.signedIn, auth]);
    useEffect(function () {
        // Get or Create a firebaseUI instance.
        loadFirebaseui();
    }, []);
    return jsx("div", { className: className, ref: elementRef });
};

var SigninRequirementReason;
(function (SigninRequirementReason) {
    SigninRequirementReason["FightCreation"] = "FightCreation";
    SigninRequirementReason["FightJoin"] = "FightJoin";
})(SigninRequirementReason || (SigninRequirementReason = {}));
var PREFIX$2 = "Login";
var classes$2 = {
    paper: "".concat(PREFIX$2, "-paper"),
    avatar: "".concat(PREFIX$2, "-avatar"),
    form: "".concat(PREFIX$2, "-form"),
    submit: "".concat(PREFIX$2, "-submit"),
};
var StyledContainer = styled(Container)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes$2.paper)] = {
            marginTop: theme.spacing(8),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        _b["& .".concat(classes$2.avatar)] = {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        _b["& .".concat(classes$2.form)] = {
            width: "100%",
            marginTop: theme.spacing(3),
        },
        _b["& .".concat(classes$2.submit)] = {
            margin: theme.spacing(3, 0, 2),
        },
        _b);
});
var Login = function (_a) {
    var reason = _a.reason, nextUrl = _a.nextUrl;
    var useTranslation = useTranslationContext().useTranslation;
    var t = useTranslation().t;
    var uiConfig = {
        siteName: "tatami",
        tosUrl: "https://tatami.app/#terms",
        privacyPolicyUrl: "https://tatami.app/#privacy",
        // Popup signin flow rather than redirect flow.
        signInFlow: "popup",
        // callbacks: {
        //   signInSuccessWithAuthResult: props.onLoggedIn,
        // },
        signInOptions: [
            GoogleAuthProvider.PROVIDER_ID,
            EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD,
        ],
        signInSuccessUrl: nextUrl,
    };
    return (jsx(StyledContainer, __assign({ maxWidth: "sm" }, { children: jsxs("div", __assign({ className: classes$2.paper }, { children: [jsx(Avatar, __assign({ className: classes$2.avatar }, { children: jsx(LockOutlinedIcon, {}) })), jsx(Typography, __assign({ component: "h1", variant: "h5" }, { children: t("user.login.header.title") })), reason && (jsx(Alert, __assign({ severity: "info" }, { children: t("user.login.reason.".concat(reason)) }))), jsx(StyledFirebaseAuth, { uiConfig: uiConfig })] })) })));
};

var PREFIX$1 = "Profile";
var classes$1 = {
    root: "".concat(PREFIX$1, "-root"),
    avatar: "".concat(PREFIX$1, "-avatar"),
};
var AvatarLabel$1 = styled("div")(function (_a) {
    var _b;
    _a.theme;
    return (_b = {},
        _b["&.".concat(classes$1.root)] = {
            display: "contents",
            alignItems: "center",
            height: "100%",
        },
        _b["& .".concat(classes$1.avatar)] = {
            height: "100%",
            width: "auto",
            aspectRatio: "1 / 1",
        },
        _b);
});
function Profile(props) {
    var _a = useProfile(props.userUid), profile = _a.profile; _a.error; var isLoading = _a.isLoading;
    var router = useRouterContext();
    var handleProfileClick = function () {
        router.navigate("/profile/".concat(profile === null || profile === void 0 ? void 0 : profile.uid));
    };
    return (jsx(React__default.Fragment, { children: jsx(AvatarLabel$1, __assign({ className: classes$1.root, sx: {
                flexDirection: props.reverse ? "row-reverse" : "",
            } }, { children: isLoading || !profile ? (jsx(Skeleton, { children: jsx(Avatar$1, { variant: "square" }) })) : (jsx(IconButton, __assign({ onClick: handleProfileClick, disableFocusRipple: true, sx: {
                    padding: "0",
                }, size: "large" }, { children: jsx(Avatar$1, { variant: "square", className: classes$1.avatar, src: profile.profilePictureUrl, onClick: handleProfileClick }) }))) })) }));
}
var defaultProps$4 = {
    reverse: false,
};
Profile.defaultProps = defaultProps$4;

var Counter = styled$1(Typography$1, {
    shouldForwardProp: function (props) { return props !== "reverse"; },
})(function (_a) {
    var reverse = _a.reverse, theme = _a.theme;
    return ({
        backgroundColor: grey[200],
        minWidth: "5em",
        maxWidth: "50%",
        textAlign: reverse ? "right" : "left",
        paddingLeft: reverse ? "1em" : "0.5em",
        paddingRight: reverse ? "0.5em" : "1em",
        borderRadius: reverse ? "0 0 0 20px" : "0 0 20px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: reverse ? "end" : "start",
        fontSize: "0.6em",
        color: theme.palette.text.primary,
    });
});
var VotesCounter = function (_a) {
    var count = _a.count, reverse = _a.reverse;
    var useTranslation = useTranslationContext().useTranslation;
    var t = useTranslation().t;
    return (jsx(Counter, __assign({ noWrap: true, reverse: reverse || false }, { children: t("fight.view.player.votes.counter", { count: count }) })));
};
var defaultProps$3 = {
    reverse: false,
};
VotesCounter.defaultProps = defaultProps$3;

var VoteButton = function (_a) {
    var disable = _a.disable, userUid = _a.userUid, color = _a.color;
    var dispatch = useAppDispatch();
    var bleacherContext = useBleacherContext();
    var voteClickHandler = function () {
        if (disable)
            return;
        bleacherContext.wsSession.send(JSON.stringify(new Vote(userUid)));
        dispatch(voteStarted());
    };
    return (jsx(Fab, __assign({ size: "small", disabled: disable, onClick: voteClickHandler, color: color }, { children: jsx(HowToVoteIcon, {}) })));
};
var defaultProps$2 = {
    disable: true,
};
VoteButton.defaultProps = defaultProps$2;

var VoteButtons = function (_a) {
    var leftUserUid = _a.leftUserUid, rightUserUid = _a.rightUserUid;
    var dispatch = useAppDispatch();
    var theme = useTheme();
    var bleacherContext = useBleacherContext();
    var ownVote = useAppSelector(selectOwnVote);
    var onWSMessageHandler = useCallback(function (event) {
        var message = JSON.parse(event.data);
        switch (message["_type"]) {
            case "VotingResultsUpdated":
                dispatch(votingResultsUpdated(message));
                break;
            case "OwnVoteLoaded":
                dispatch(voteLoaded(message));
                break;
            case "Voted":
                dispatch(voted(message.vote));
                break;
        }
    }, [dispatch]);
    React__default.useEffect(function () {
        if (bleacherContext.wsSession.readyState !== WebSocket.OPEN)
            return;
        bleacherContext.wsSession.addEventListener("message", onWSMessageHandler);
        bleacherContext.wsSession.send(JSON.stringify(LoadVoting));
        dispatch(loadingOwnVote());
        return function () {
            bleacherContext.wsSession.removeEventListener("message", onWSMessageHandler);
        };
    }, [bleacherContext.wsSession, dispatch, onWSMessageHandler]);
    return (jsxs(Box, __assign({ sx: {
            width: "100%",
            display: "flex",
            padding: theme.spacing(2),
            paddingTop: 0,
            justifyContent: "space-between",
        } }, { children: [jsx(VoteButton, { color: "primary", disable: ownVote.fighterUid === leftUserUid ||
                    ownVote.state !== AsyncState.Completed, userUid: leftUserUid }), jsx(VoteButton, { color: "secondary", disable: ownVote.fighterUid === rightUserUid ||
                    ownVote.state !== AsyncState.Completed, userUid: rightUserUid })] })));
};

var Scorer = function (_a) {
    var _b;
    var leftUserUid = _a.leftUserUid, rightUserUid = _a.rightUserUid, voteResults = _a.voteResults, votingEnable = _a.votingEnable;
    var theme = useTheme();
    if (!voteResults)
        return null;
    var _c = [
        voteResults[leftUserUid] || { userUid: leftUserUid, votes: 0 },
        voteResults[rightUserUid] || { userUid: rightUserUid, votes: 0 },
    ], leftSide = _c[0], rightSide = _c[1];
    var leftVotes = leftSide.votes;
    var rightVotes = rightSide.votes;
    var totalVotes = leftVotes + rightVotes;
    var hasVotes = totalVotes > 0;
    var percentOfLeftSideVotes = hasVotes
        ? Math.round((leftVotes / totalVotes) * 100)
        : 50;
    return (jsxs(React__default.Fragment, { children: [jsxs(Box, __assign({ sx: (_b = {
                        width: "100%",
                        height: "4em"
                    },
                    _b[theme.breakpoints.down("md")] = {
                        height: "3em",
                    },
                    _b[theme.breakpoints.up("xs")] = {
                        padding: theme.spacing(1),
                    },
                    _b.display = "flex",
                    _b.padding = theme.spacing(2),
                    _b) }, { children: [jsx(Profile, { userUid: leftUserUid }), jsxs(Box, __assign({ sx: {
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                        } }, { children: [jsx(LinearProgress, { sx: {
                                    borderTopLeftRadius: 0,
                                    borderTopRightRadius: 0,
                                    borderBottomLeftRadius: 0,
                                    borderBottomRightRadius: 0,
                                    height: "50%",
                                    width: "100%",
                                    backgroundColor: theme.palette.secondary.light,
                                }, value: percentOfLeftSideVotes, variant: "determinate", classes: {
                                    barColorPrimary: theme.palette.primary.main,
                                } }), jsxs(Box, __assign({ sx: {
                                    width: "100%",
                                    height: "50%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                } }, { children: [jsx(VotesCounter, { count: leftVotes }), jsx(VotesCounter, { reverse: true, count: rightVotes })] }))] })), jsx(Profile, { reverse: true, userUid: rightUserUid })] })), votingEnable ? (jsx(VoteButtons, { leftUserUid: leftUserUid, rightUserUid: rightUserUid })) : null] }));
};

var ActiveScorer = function (_a) {
    var leftUserUid = _a.leftUserUid, rightUserUid = _a.rightUserUid;
    var dispatch = useAppDispatch();
    useTheme();
    var bleacherContext = useBleacherContext();
    var voteResults = bleacherContext.voting;
    var onWSMessageHandler = useCallback(function (event) {
        var message = JSON.parse(event.data);
        switch (message["_type"]) {
            case "VotingResultsUpdated":
                dispatch(votingResultsUpdated(message));
                break;
            case "Voted":
                dispatch(voted(message.vote));
                break;
        }
    }, [dispatch]);
    React__default.useEffect(function () {
        if (bleacherContext.wsSession.readyState !== WebSocket.OPEN)
            return;
        bleacherContext.wsSession.addEventListener("message", onWSMessageHandler);
        bleacherContext.wsSession.send(JSON.stringify(LoadVoting));
        return function () {
            bleacherContext.wsSession.removeEventListener("message", onWSMessageHandler);
        };
    }, [bleacherContext.wsSession, onWSMessageHandler]);
    if (!voteResults)
        return null;
    return (jsx(Scorer, { leftUserUid: leftUserUid, rightUserUid: rightUserUid, voteResults: voteResults, votingEnable: true }));
};

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "#2d57c2",
      fill: "#6bc9df"
    },
    transform: "rotate(90 131.725 162.488)",
    d: "M143.685-44.369h337.466v165.161H143.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "#2d57c2",
      fill: "#6b92df"
    },
    transform: "rotate(90 45.032 75.763)",
    d: "M143.718-44.369h337.551v145.161a20 20 0 0 1-20 20H143.718V-44.369Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "#2d57c2",
      fill: "#ca81de"
    },
    transform: "rotate(90 218.447 249.181)",
    d: "M143.713-44.371h317.534a20 20 0 0 1 20 20V120.79H143.713V-44.371Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "#2d57c2",
      fill: "#6bc9df"
    },
    transform: "rotate(90 158.966 88.66)",
    d: "M70.31-90.956h165.134v338.582H90.31a20 20 0 0 1-20-20V-90.956Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      paintOrder: "stroke",
      stroke: "#2d57c2",
      fill: "#de9554"
    },
    transform: "rotate(90 268.97 198.66)",
    d: "M90.31-44.369h145.134v165.161H70.31V-24.369a20 20 0 0 1 20-20Z"
  }));
};

var PlayerToolbar = styled$1(Toolbar)(function (_a) {
    _a.theme;
    return ({
        width: "100%",
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        zIndex: 1,
        bottom: "0",
        minHeight: "5em",
        background: "linear-gradient(0deg, rgba(158, 158, 158,0.1) 0%, rgba(158, 158, 158,1) 100%);",
        "& .MuiIconButton-root": {
            "& svg": {
                fill: lightBlue[50],
            },
        },
        "& .left-controls": {
            alignSelf: "start",
            alignItems: "center",
        },
        "& .right-controls": {
            alignSelf: "flex-end",
            alignItems: "center",
        },
    });
});
var VideoControls = function (_a) {
    var _b, _c, _d, _e;
    var videoEl = _a.videoEl, wrapperEl = _a.wrapperEl, hls = _a.hls, shown = _a.shown, mode = _a.mode;
    var seekInput = useRef(null);
    var _f = useState(typeof ((_b = videoEl.current) === null || _b === void 0 ? void 0 : _b.paused) === "boolean"
        ? !((_c = videoEl.current) === null || _c === void 0 ? void 0 : _c.paused)
        : false), playing = _f[0], setPlaying = _f[1];
    var _g = useState((typeof document !== "undefined" && !!document.fullscreenElement) || false), fullScreen = _g[0], setFullScreen = _g[1];
    var _h = useState((_d = videoEl.current) === null || _d === void 0 ? void 0 : _d.duration), duration = _h[0], setDuration = _h[1];
    // const [bufferedDuration, setBufferedDuration] = useState<number | undefined>(
    //   undefined
    // );
    var updatingEllapsed = useRef(true);
    var _j = useState(((_e = videoEl.current) === null || _e === void 0 ? void 0 : _e.currentTime) || 0), ellapsedTime = _j[0], setEllapsedTime = _j[1];
    var handlePlayPause = function () {
        var _a, _b;
        playing ? (_a = videoEl.current) === null || _a === void 0 ? void 0 : _a.pause() : (_b = videoEl.current) === null || _b === void 0 ? void 0 : _b.play();
    };
    var handleToggleFullScreen = function () {
        var _a;
        document.fullscreenElement
            ? document.exitFullscreen()
            : (_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.requestFullscreen({ navigationUI: "hide" });
    };
    var handleVideoTimeUpdate = function (e) {
        var _a;
        if (updatingEllapsed.current && videoEl.current)
            setEllapsedTime((_a = videoEl.current) === null || _a === void 0 ? void 0 : _a.currentTime);
    };
    useEffect(function () {
        var _a, _b, _c, _d;
        (_a = videoEl.current) === null || _a === void 0 ? void 0 : _a.addEventListener("loadedmetadata", function () {
            var _a;
            setDuration((_a = videoEl.current) === null || _a === void 0 ? void 0 : _a.duration);
        });
        (_b = videoEl.current) === null || _b === void 0 ? void 0 : _b.addEventListener("play", function () {
            setPlaying(true);
        });
        (_c = videoEl.current) === null || _c === void 0 ? void 0 : _c.addEventListener("pause", function () {
            setPlaying(false);
        });
        (_d = videoEl.current) === null || _d === void 0 ? void 0 : _d.addEventListener("timeupdate", handleVideoTimeUpdate);
    });
    useEffect(function () {
        var callback = function () {
            setFullScreen(!!document.fullscreenElement);
        };
        document.addEventListener("fullscreenchange", callback);
        return function () {
            document.removeEventListener("fullscreenchange", callback);
        };
    });
    useEffect(function () {
        if (!hls)
            return;
        hls.once(Hls.Events.LEVEL_LOADED, function (e, data) {
            var _a, _b;
            setDuration(((_b = (_a = hls.levels.find(function (l) { var _a, _b; return typeof ((_a = l.details) === null || _a === void 0 ? void 0 : _a.totalduration) !== "undefined" && !((_b = l.details) === null || _b === void 0 ? void 0 : _b.live); })) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.totalduration) || 0);
        });
        // hls.on(Hls.Events.FRAG_BUFFERED, function (eventName, data) {
        //   console.log(data.frag.end); TODO for adding the buffer progress
        // });
    }, [hls]);
    var handleSeekChange = function (e, value) {
        if (!videoEl.current)
            return;
        var skipTo = value;
        // videoEl.current.currentTime = skipTo;
        updatingEllapsed.current = false;
        setEllapsedTime(skipTo);
    };
    var handleSeekChangeCommitted = function (e, value) {
        if (!videoEl.current)
            return;
        var skipTo = value;
        videoEl.current.currentTime = skipTo;
        setEllapsedTime(skipTo);
        updatingEllapsed.current = true;
    };
    return (jsx(Slide, __assign({ direction: "up", timeout: 500, in: shown, container: wrapperEl.current }, { children: jsxs(PlayerToolbar, { children: [jsx(Slider, { max: duration, min: 0, value: Math.floor(ellapsedTime), onChange: handleSeekChange, onChangeCommitted: handleSeekChangeCommitted, ref: seekInput }), jsxs(Box, __assign({ sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    } }, { children: [jsxs(Stack, __assign({ className: "left-controls", direction: "row", spacing: 2 }, { children: [jsx(IconButton, __assign({ onClick: handlePlayPause, color: "primary" }, { children: playing ? jsx(PauseIcon, {}) : jsx(PlayArrowIcon, {}) })), mode === FightMediaMode.VOD ? (jsxs("div", { children: [jsx("time", { children: toHHMMSS(ellapsedTime) }), duration && (jsxs(React__default.Fragment, { children: [jsx("span", { children: " / " }), jsxs("time", { children: [" ", toHHMMSS(duration)] })] }))] })) : null] })), jsx(Stack, __assign({ className: "right-controls", direction: "row", spacing: 2 }, { children: jsx(IconButton, __assign({ onClick: handleToggleFullScreen, color: "primary" }, { children: fullScreen ? jsx(FullscreenExitIcon, {}) : jsx(FullscreenIcon, {}) })) }))] }))] }) })));
};

var defaultVideoOptions = {
    controls: false,
    autoPlay: false,
};
var FightVideo = function (_a) {
    var playerOptions = _a.playerOptions, title = _a.title, playbackUrl = _a.playbackUrl, leftUserUid = _a.leftUserUid, rightUserUid = _a.rightUserUid, titleEnabled = _a.titleEnabled, mediaMode = _a.mediaMode, results = _a.results, controls = _a.controls, playable = _a.playable;
    var wrapperEl = React__default.useRef(null);
    var videoNode = React__default.useRef(null);
    var hlsRef = React__default.useRef();
    var _b = useState(false), playing = _b[0], setPlaying = _b[1];
    var _c = useState(false), showingControls = _c[0], setShowingControls = _c[1];
    var options = __assign(__assign({}, defaultVideoOptions), (playerOptions || {}));
    var onPlayFailed = useCallback(function (error) {
        console.error("Unable to play the video", error);
    }, []);
    useEffect(function () {
        if (Hls.isSupported()) {
            hlsRef.current = new Hls({
                autoStartLoad: true,
                backBufferLength: 90,
                maxBufferLength: 10,
                maxMaxBufferLength: 30,
            });
        }
        var hls = hlsRef.current;
        return function () {
            hls === null || hls === void 0 ? void 0 : hls.destroy();
        };
    }, []);
    useEffect(function () {
        var hls = hlsRef.current;
        if (videoNode.current) {
            var retries_1 = 0;
            videoNode.current.volume = 1;
            if (Hls.isSupported() && hls) {
                hls.attachMedia(videoNode.current);
                hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                    hls.loadSource(playbackUrl);
                    // hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                    //videoNode.current?.play().catch(onPlayFailed);
                    // });
                });
                hls.on(Hls.Events.ERROR, function (event, data) {
                    if (data.fatal) {
                        switch (data.type) {
                            case Hls.ErrorTypes.NETWORK_ERROR:
                                // try to recover network error
                                if (retries_1 > 1)
                                    return;
                                console.warn("fatal network error encountered, try to recover");
                                if (data.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR ||
                                    data.details === Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT ||
                                    data.details === Hls.ErrorDetails.MANIFEST_PARSING_ERROR) {
                                    window.setTimeout(function () { return hls.loadSource(playbackUrl); }, 1000);
                                }
                                else {
                                    window.setTimeout(hls.startLoad, 1000);
                                }
                                retries_1 = retries_1 + 1;
                                break;
                            case Hls.ErrorTypes.MEDIA_ERROR:
                                console.warn("fatal media error encountered, try to recover");
                                hls.recoverMediaError();
                                break;
                            default:
                                // cannot recover
                                hls.destroy();
                                break;
                        }
                    }
                });
            }
            else if (videoNode.current.canPlayType("application/vnd.apple.mpegurl")) {
                videoNode.current.src = playbackUrl;
                // videoNode.current.addEventListener("canplay", function () {
                // this.play().catch(onPlayFailed);
                // });
            }
        }
        return function () { };
    }, [playbackUrl]);
    useEffect(function () {
        if (!controls)
            return;
        var timeout;
        var wrapper = wrapperEl.current;
        var mouseMoveHandler = function () {
            setShowingControls(true);
            if (timeout)
                clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                setShowingControls(false);
            }, 3000);
        };
        var mouseOverHanddler = function () {
            setShowingControls(true);
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.addEventListener("mousemove", mouseMoveHandler);
        };
        var mouseOutHanddler = function () {
            if (timeout)
                clearTimeout(timeout);
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.removeEventListener("mousemove", mouseMoveHandler);
            setShowingControls(false);
        };
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.addEventListener("mouseover", mouseOverHanddler);
        wrapper === null || wrapper === void 0 ? void 0 : wrapper.addEventListener("mouseout", mouseOutHanddler);
        return function () {
            if (!controls)
                return;
            if (timeout)
                clearTimeout(timeout);
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.removeEventListener("mousemove", mouseMoveHandler);
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.removeEventListener("mouseover", mouseOverHanddler);
            wrapper === null || wrapper === void 0 ? void 0 : wrapper.removeEventListener("mouseout", mouseOutHanddler);
        };
    }, []);
    useEffect(function () {
        var _a, _b;
        (_a = videoNode.current) === null || _a === void 0 ? void 0 : _a.addEventListener("play", function () {
            setPlaying(true);
        });
        (_b = videoNode.current) === null || _b === void 0 ? void 0 : _b.addEventListener("pause", function () {
            setPlaying(false);
        });
    });
    var handlePlayClick = function () {
        var _a;
        if (playable === false)
            return;
        (_a = videoNode.current) === null || _a === void 0 ? void 0 : _a.play().catch(onPlayFailed);
    };
    var handleTogglePlay = function () {
        var _a, _b;
        if (playable === false)
            return;
        playing
            ? (_a = videoNode.current) === null || _a === void 0 ? void 0 : _a.pause()
            : (_b = videoNode.current) === null || _b === void 0 ? void 0 : _b.play().catch(onPlayFailed);
    };
    var scorer = results ? (jsx$1(Scorer, { leftUserUid: leftUserUid, rightUserUid: rightUserUid, voteResults: results, votingEnable: false })) : (jsx$1(ActiveScorer, { leftUserUid: leftUserUid, rightUserUid: rightUserUid }));
    var header = titleEnabled ? (jsx$1(Slide, __assign({ direction: "down", timeout: 500, in: showingControls, container: wrapperEl.current }, { children: jsx$1(Box, __assign({ sx: {
                height: "3em",
                visibility: "visible !important",
                overflow: "visible",
            } }, { children: jsxs$1(Stack, __assign({ spacing: 2, direction: "row", sx: {
                    background: "linear-gradient(0deg, rgba(158, 158, 158,0) 0%, rgba(158, 158, 158,1) 100%);",
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    alignItems: "center",
                    height: "3em",
                }, p: 2 }, { children: [jsx$1(SvgIcon, { component: SvgLogo, inheritViewBox: true }), jsx$1(Typography$1, __assign({ noWrap: true, variant: "h5" }, { children: title }))] })) })) }))) : (scorer);
    return (jsxs$1(Box, __assign({ ref: wrapperEl, sx: {
            position: "relative",
            overflow: "hidden",
            display: "flex",
            width: "100%",
            color: lightBlue[50],
            "&:fullscreen .life-bars": {
                top: "clamp(0px, calc((100vh - (100vw / (16/9))) / 2 ), 90vh)",
            },
        } }, { children: [jsx$1(Box, __assign({ sx: { position: "absolute", width: "100%", top: 0, zIndex: 1 }, className: "life-bars" }, { children: header })), jsx$1(Box, __assign({ css: css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n          position: absolute;\n          z-index: 1;\n          top: 50%;\n          left: 50%;\n          transform: translateX(-50%) translateY(-50%);\n        "], ["\n          position: absolute;\n          z-index: 1;\n          top: 50%;\n          left: 50%;\n          transform: translateX(-50%) translateY(-50%);\n        "]))) }, { children: jsx$1(Grow, __assign({ timeout: 1000, in: !playing }, { children: jsx$1(IconButton, __assign({ color: "third", onClick: handlePlayClick }, { children: jsx$1(PlayArrowIcon, { css: css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n                border: 0.04em solid;\n                border-radius: 4em;\n                font-size: 4em;\n              "], ["\n                border: 0.04em solid;\n                border-radius: 4em;\n                font-size: 4em;\n              "]))) }) })) })) })), jsx$1("video", { preload: "metadata", width: "100%", playsInline: true, ref: videoNode, autoPlay: options.autoPlay, controls: options.controls, css: css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n          z-index: 0;\n          background: rgba(158, 158, 158, 0.1);\n        "], ["\n          z-index: 0;\n          background: rgba(158, 158, 158, 0.1);\n        "]))), onClick: handleTogglePlay }), controls ? (jsx$1(VideoControls, { shown: showingControls, hls: hlsRef.current, videoEl: videoNode, wrapperEl: wrapperEl, mode: mediaMode })) : null] })));
};
var templateObject_1$2, templateObject_2$2, templateObject_3$2;

function MessageForm(props) {
    var chatContext = useChatContext();
    var useTranslation = useTranslationContext().useTranslation;
    var t = useTranslation().t;
    var textInputField = useRef();
    var data = useSigninCheck().data;
    var router = useRouterContext();
    var signInResult = data;
    var validationSchema = yup.object({
        text: yup.string().min(1).required("A message is required"),
    });
    var formik = useFormik({
        initialValues: {
            text: "",
        },
        validationSchema: validationSchema,
        onSubmit: function (values) {
            var _a;
            if (chatContext.wsSession.readyState !== WebSocket.OPEN)
                return;
            chatContext.wsSession.send(JSON.stringify(new SendChatMessage(values.text)));
            formik.resetForm();
            (_a = textInputField.current) === null || _a === void 0 ? void 0 : _a.focus();
        },
    });
    var handleSubmitClick = function () {
        formik.submitForm();
    };
    var handleKeyboardInteractions = function (e) {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            formik.submitForm();
        }
    };
    var handleFocus = function () {
        if (!signInResult.signedIn && (window === null || window === void 0 ? void 0 : window.location)) {
            if (window.location.hostname === "demo.tatami.app") {
                return router.navigate("/login?next=".concat(encodeURIComponent(window.location.pathname)).concat(window.location.search));
            }
            else {
                return (window.location.href = "https://demo.tatami.app/fights/view/".concat(encodeURIComponent(chatContext.fight.title), "?f=").concat(chatContext.fight.uid));
            }
        }
    };
    return (jsx("form", __assign({ onSubmit: formik.handleSubmit }, { children: jsxs(FormControl, __assign({ disabled: chatContext.wsSession.readyState !== WebSocket.OPEN, fullWidth: true, sx: { padding: "0.3em" } }, { children: [jsx(InputLabel, __assign({ htmlFor: "text" }, { children: t("fight.chat.form.input.message.label") })), jsx(FilledInput, { inputRef: textInputField, id: "text", name: "text", type: "text", value: formik.values.text, onFocus: handleFocus, onChange: formik.handleChange, onKeyUp: handleKeyboardInteractions, placeholder: t("fight.chat.form.input.message.placeholder") || undefined, autoComplete: "off", endAdornment: jsx(IconButton, __assign({ onClick: handleSubmitClick, color: "primary", component: "label" }, { children: jsx(SendIcon, {}) })) })] })) })));
}

styled(Paper)(function (_a) {
    var usercolor = _a.usercolor, theme = _a.theme;
    return ({
        backgroundColor: usercolor,
        padding: theme.spacing(2),
        borderRadius: 0,
    });
});
function MessageText(props) {
    return (
    // <StyledPaper usercolor={props.color}>
    jsxs(Typography$1, __assign({ sx: { display: "inline", overflowWrap: "anywhere" }, component: "p", variant: "subtitle2", color: "text.primary" }, { children: [jsx(Typography$1, __assign({ sx: { display: "inline" }, component: "span", variant: "body1", color: props.color }, { children: props.userDisplayName })), ": ", props.text] }))
    // </StyledPaper>
    );
}

function Message(_a) {
    var message = _a.message;
    var _b = useProfile(message.authorUid), profile = _b.profile; _b.error; _b.isLoading;
    var backgroundColor = function (opacity) {
        return "rgba(".concat(profile === null || profile === void 0 ? void 0 : profile.color.r, ", ").concat(profile === null || profile === void 0 ? void 0 : profile.color.g, ", ").concat(profile === null || profile === void 0 ? void 0 : profile.color.b, ", ").concat(opacity, ")");
    };
    if (!(profile === null || profile === void 0 ? void 0 : profile.displayName))
        return null;
    return (jsx(Zoom, __assign({ appear: true, in: true }, { children: jsx(ListItem, __assign({ alignItems: "flex-start" }, { children: jsx(ListItemText, { primary: jsx(MessageText, { userDisplayName: (profile === null || profile === void 0 ? void 0 : profile.displayName) || "", text: message.text, color: backgroundColor(1) }) }) })) })));
}

var defaultProps$1 = {
    reverse: false,
};
var ChatBox = function (_a) {
    var _b;
    var reverse = _a.reverse;
    var useTranslation = useTranslationContext().useTranslation;
    var t = useTranslation().t;
    var _c = useChatContext(), wsSession = _c.wsSession, chat = _c.chat;
    var dispatch = useAppDispatch();
    var theme = useTheme();
    var onWSMessageHandler = useCallback(function (event) {
        var message = JSON.parse(event.data);
        switch (message["_type"]) {
            case "ChatMessageReceived":
                var chatMessage = message.message;
                dispatch(chatMessageReceived(chatMessage));
                break;
        }
    }, [dispatch]);
    useEffect(function () {
        wsSession.addEventListener("message", onWSMessageHandler);
        return function () {
            wsSession.removeEventListener("message", onWSMessageHandler);
        };
    }, [wsSession, onWSMessageHandler]);
    useEffect(function () {
        return function () {
            dispatch(resetChat());
        };
    }, []);
    return (jsxs(Box, __assign({ sx: (_b = {
                display: "flex",
                overflowY: "auto",
                flexDirection: reverse ? "column" : "column-reverse",
                // [theme.breakpoints.up("sm")]: {
                height: "100%"
            },
            // },
            _b[theme.breakpoints.down("md")] = {
                minHeight: "40vh",
            },
            _b) }, { children: [jsx(Box, __assign({ alignItems: "flex-end" }, { children: jsx(MessageForm, {}) })), jsx(Box, __assign({ alignItems: "flex-end", sx: { flexDirection: reverse ? "column-reverse" : "column" } }, { children: jsxs(List, __assign({ sx: {
                        width: "100%",
                        bgcolor: "background.paper",
                        // overflowY: "auto",
                        height: "100%",
                        display: !reverse ? null : "flex",
                        flexDirection: !reverse ? null : "column-reverse",
                    }, dense: true }, { children: [jsx(ListItem, __assign({ alignItems: "flex-start" }, { children: jsx(ListItemText, { secondary: t("fight.chat.list.messages.welcome") }) })), chat.messages.map(function (message) { return (jsx(Message, { message: message }, message.id)); })] })) }))] })));
};
ChatBox.defaultProps = defaultProps$1;

var FightDetails = function (_a) {
    var fightMeta = _a.fightMeta;
    var useTranslation = useTranslationContext().useTranslation;
    useTheme();
    var t = useTranslation().t;
    return (jsxs$1(Grid, __assign({ container: true, rowSpacing: 1, columns: 11 }, { children: [jsx$1(Grid, __assign({ item: true, xs: 11 }, { children: jsxs$1(Typography$1, __assign({ variant: "h6" }, { children: [jsx$1(Chip, { color: "primary", 
                            // variant="outlined"
                            sx: {
                                marginRight: "1em",
                            }, label: t("language.".concat(fightMeta.lang)), size: "small" }), fightMeta.title] })) })), jsx$1(Grid, __assign({ item: true, xs: 11 }, { children: jsx$1(Typography$1, __assign({ variant: "body2" }, { children: fightMeta.description })) }))] })));
};

var PREFIX = "Profile";
var classes = {
    root: "".concat(PREFIX, "-root"),
    avatar: "".concat(PREFIX, "-avatar"),
};
var AvatarLabel = styled("div")(function (_a) {
    _a.theme;
    return ({});
});
var ProfileThumb = function Profile(props) {
    var _a = useProfile(props.userUid), profile = _a.profile, error = _a.error, isLoading = _a.isLoading;
    var router = useRouterContext();
    var theme = useTheme();
    if (error)
        return jsx("div", { children: "failed to load" });
    var handleProfileClick = function () {
        router.navigate("/profile/".concat(profile === null || profile === void 0 ? void 0 : profile.uid));
    };
    return (jsx(React__default.Fragment, { children: jsx(AvatarLabel, __assign({ className: classes.root, sx: {
                flexDirection: props.reverse ? "row-reverse" : "",
            } }, { children: isLoading ? (jsx(Skeleton, { children: jsx(Avatar$1, { variant: "rounded", sx: { width: "3em", height: "3em" } }) })) : (jsx(IconButton, __assign({ onClick: handleProfileClick, sx: {
                    borderRadius: "12%",
                    padding: "4px",
                    "&:hover": {
                        backgroundColor: alpha(props.reverse
                            ? theme.palette.secondary.main
                            : theme.palette.primary.main, 0.4),
                    },
                }, size: "large" }, { children: jsx(Avatar$1, { variant: "rounded", sizes: "", className: classes.avatar, src: profile === null || profile === void 0 ? void 0 : profile.profilePictureUrl, sx: { width: "3em", height: "3em" } }) }))) })) }));
};
var defaultProps = {
    reverse: false,
};
ProfileThumb.defaultProps = defaultProps;

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgVs$1 = function SvgVs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#6bc9df",
      fontFamily: "Signika",
      fontSize: "70.1px",
      fontStyle: "italic",
      fontWeight: 700,
      strokeWidth: 3,
      whiteSpace: "pre"
    },
    x: 24.277,
    y: 72.452,
    transform: "matrix(1 0 -.15241 1 -8.507 -3.751)"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#e4aa76",
      fontFamily: "Signika",
      fontSize: "72.2px",
      fontStyle: "italic",
      fontWeight: 700,
      whiteSpace: "pre"
    },
    x: 100.074,
    y: 127.667,
    transform: "matrix(1 0 -.06735 1 -32.774 -12.806)"
  }, "S"), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "#000",
      strokeWidth: 3
    },
    d: "m14.749 113.276 96.651-97.13"
  }));
};

var Participants = function (_a) {
    var leftUserUid = _a.leftUserUid, rightUserUid = _a.rightUserUid;
    var theme = useTheme();
    var router = useRouterContext();
    var _b = useProfile(leftUserUid), leftProfile = _b.profile; _b.error; _b.isLoading;
    var _c = useProfile(rightUserUid), rightProfile = _c.profile; _c.error; _c.isLoading;
    var handleProfileClick = function (uid) { return function () {
        router.navigate("/profile/".concat(uid));
    }; };
    return (jsxs$1(Grid, __assign({ container: true, rowSpacing: 1, columns: 11 }, { children: [jsx$1(Grid, __assign({ item: true, xs: 11, md: 5 }, { children: jsxs$1(Box, __assign({ sx: {
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        alignContent: "center",
                        flexWrap: "nowrap",
                    } }, { children: [jsx$1(Box, __assign({ alignSelf: "flex-start" }, { children: jsx$1(ProfileThumb, { userUid: leftUserUid }) })), jsxs$1("div", __assign({ css: css$1(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n              border-color: green;\n              width: 100%;\n              margin: 0 1em;\n              // transform: translateY(-50%);\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              overflow: hidden;\n            "], ["\n              border-color: green;\n              width: 100%;\n              margin: 0 1em;\n              // transform: translateY(-50%);\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              overflow: hidden;\n            "]))) }, { children: [(leftProfile === null || leftProfile === void 0 ? void 0 : leftProfile.displayName) ? (jsx$1(Link, __assign({ onClick: handleProfileClick(leftProfile.uid), underline: "none", component: "button", variant: "h6" }, { children: leftProfile.displayName }))) : ("???"), jsx$1("hr", { css: css$1(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n                border: 2px solid ", ";\n                width: 100%;\n                margin: 0;\n              "], ["\n                border: 2px solid ", ";\n                width: 100%;\n                margin: 0;\n              "])), theme.palette.primary.main) })] }))] })) })), jsx$1(Grid, __assign({ item: true, xs: 11, md: 1, textAlign: "center" }, { children: jsx$1(SvgVs$1, { css: css$1(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n            min-width: 4em;\n          "], ["\n            min-width: 4em;\n          "]))), width: "4em" }) })), jsx$1(Grid, __assign({ item: true, xs: 11, md: 5 }, { children: jsxs$1(Box, __assign({ sx: {
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        alignContent: "center",
                        flexWrap: "nowrap",
                    } }, { children: [jsxs$1("div", __assign({ css: css$1(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n              border-color: green;\n              width: 100%;\n              margin: 0 1em;\n              // transform: translateY(-50%);\n              text-align: end;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              overflow: hidden;\n            "], ["\n              border-color: green;\n              width: 100%;\n              margin: 0 1em;\n              // transform: translateY(-50%);\n              text-align: end;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              overflow: hidden;\n            "]))) }, { children: [(rightProfile === null || rightProfile === void 0 ? void 0 : rightProfile.displayName) ? (jsx$1(Link, __assign({ variant: "h6", onClick: handleProfileClick(rightProfile.uid), underline: "none", component: "button", color: "secondary" }, { children: rightProfile.displayName }))) : ("???"), jsx$1("hr", { css: css$1(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n                border: 2px solid ", ";\n                width: 100%;\n                margin: 0;\n              "], ["\n                border: 2px solid ", ";\n                width: 100%;\n                margin: 0;\n              "])), theme.palette.secondary.main) })] })), jsx$1(Box, __assign({ alignSelf: "flex-end" }, { children: jsx$1(ProfileThumb, { userUid: rightUserUid, reverse: true }) }))] })) }))] })));
};
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1;

var Details = function (_a) {
    var leftUserUid = _a.leftUserUid, rightUserUid = _a.rightUserUid, fightMeta = _a.fightMeta;
    return (jsxs$1(Fragment, { children: [jsx$1(FightDetails, { fightMeta: fightMeta }), jsx$1(Participants, { leftUserUid: leftUserUid, rightUserUid: rightUserUid })] }));
};

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgVs = function SvgVs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#6bc9df",
      fontFamily: "Signika",
      fontSize: "70.1px",
      fontStyle: "italic",
      fontWeight: 700,
      strokeWidth: 3,
      whiteSpace: "pre"
    },
    x: 24.277,
    y: 72.452,
    transform: "matrix(1 0 -.15241 1 -8.507 -3.751)"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#e4aa76",
      fontFamily: "Signika",
      fontSize: "72.2px",
      fontStyle: "italic",
      fontWeight: 700,
      whiteSpace: "pre"
    },
    x: 100.074,
    y: 127.667,
    transform: "matrix(1 0 -.06735 1 -32.774 -12.806)"
  }, "S"), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "#000",
      strokeWidth: 3
    },
    d: "m14.749 113.276 96.651-97.13"
  }));
};

var FightersLegend = function (_a) {
    var leftSeatUserUid = _a.leftSeatUserUid, rightSeatUserUid = _a.rightSeatUserUid;
    var theme = useTheme();
    var _b = useProfile(leftSeatUserUid), leftProfile = _b.profile; _b.error; _b.isLoading;
    var _c = useProfile(rightSeatUserUid), rightProfile = _c.profile; _c.error; _c.isLoading;
    return (jsxs$1(Box, __assign({ sx: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignContent: "center",
            flexWrap: "nowrap",
        } }, { children: [jsx$1(Box, __assign({ alignSelf: "flex-start" }, { children: jsx$1(ProfileThumb, { userUid: leftSeatUserUid }) })), jsxs$1(Box, __assign({ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", width: "6em" }, { children: [jsxs$1("div", __assign({ css: css$1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            border-color: green;\n            width: 100%;\n            margin: 0 1em;\n            transform: translateY(-50%);\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n          "], ["\n            border-color: green;\n            width: 100%;\n            margin: 0 1em;\n            transform: translateY(-50%);\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n          "]))) }, { children: [leftProfile === null || leftProfile === void 0 ? void 0 : leftProfile.displayName, jsx$1("hr", { css: css$1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              border: 2px solid ", ";\n\n              width: 100%;\n              margin: 0;\n            "], ["\n              border: 2px solid ", ";\n\n              width: 100%;\n              margin: 0;\n            "])), theme.palette.primary.main) })] })), jsx$1(SvgVs, { css: css$1(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            min-width: 4em;\n          "], ["\n            min-width: 4em;\n          "]))), width: "4em" }), jsxs$1("div", __assign({ css: css$1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            border-color: green;\n            width: 100%;\n            margin: 0 1em;\n            transform: translateY(-50%);\n            text-align: end;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n          "], ["\n            border-color: green;\n            width: 100%;\n            margin: 0 1em;\n            transform: translateY(-50%);\n            text-align: end;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n          "]))) }, { children: [rightProfile === null || rightProfile === void 0 ? void 0 : rightProfile.displayName, jsx$1("hr", { css: css$1(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n              border: 2px solid ", ";\n              width: 100%;\n              margin: 0;\n            "], ["\n              border: 2px solid ", ";\n              width: 100%;\n              margin: 0;\n            "])), theme.palette.secondary.main) })] }))] })), jsx$1(Box, __assign({ alignSelf: "flex-end" }, { children: jsx$1(ProfileThumb, { userUid: rightSeatUserUid }) }))] })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { API, BleacherContextProvider, ChatBox, ChatContextProvider, ClientPreparationStep, Details, FightDetails, FightMediaMode, FightPhaseName, FightStatus, FightVideo, FightersLegend, Login, SvgLogo as Logo, MediaDevicesKeys, Participants, PreparationStepState, ProfileThumb, RouterContextProvider, SigninRequirementReason, StreamEventState, TranslationContextProvider, USER_FIGHTS_PAGE_SIZE, SvgVs as VsIcon, WSState, availableActionsChanged, bleacherReducer, bleacherSlice, chatMessageReceived, chatSlice, cleanDeviceSelection, clearLoginState, createFight, createFightSlice, enumFromValue, fetchFights, fetchIceServers, fetchSessionState, fightError, fightLoaded, fightMediaChanged, fightMediaLoaded, fightParticipantsChanged, fightRoomJoined, fightRoomLeft, fightRoomSlice, fightRoomWSConnected, fightSlice, fightStatusChanged, formatMinutes, homeSlice, iceServersUnused, loadingOwnVote, mediaDevicesSlice, preparationStepUpdate, profileFetcher, recordingStateChanged, resetBleacher, resetChat, resetFight, resetFightRoom, resetHome, selectAvailableActions, selectBleacher, selectChat, selectCurrentUser, selectDeviceSelection, selectError, selectFight, selectFightRoom, selectHomeState, selectIceServers, selectOwnVote, selectSessionState, selectVoteResults, sessionSlice, setCurrentFight, setDeviceSelection, statsFetcher, store, streamStateUpdated, tatamiTheme, toHHMMSS, useAppDispatch, useAppSelector, useBleacher, useBleacherContext, useChatContext, useProfile, useProfileStats, useQuery, useRouterContext, useScript, useTranslationContext, useUserFights, userFightsFetcher, voteLoaded, voteStarted, voted, votingResultsUpdated, webrtcSlice };
